/** Platzhalter-Zeilen während des Ladens – ersetzt den reinen "Wird geladen…"-Text. */
export function TableSkeleton({ rows = 5, widths = [40, 25, 20, 15] }: { rows?: number; widths?: number[] }) {
  return (
    <div>
      {Array.from({ length: rows }, (_, i) => (
        <div className="skel-row" key={i}>
          {widths.map((w, j) => (
            <div key={j} className="skel-bar" style={{ width: `${w}%` }} />
          ))}
        </div>
      ))}
    </div>
  );
}
